import { Categoria } from '../../shared/entity/Categoria';
import { RouteProp, CompositeNavigationProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';
import { StackParamList, DrawerParamList } from '../../../App';
import pedidoApi from '../../apis/pedidoApi';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING } from '../../constants';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import Pedido from '../../shared/entity/Pedido';
import ItemPedido from './ItemPedido';

type Props = {
  navigation: CompositeNavigationProp<
    StackNavigationProp<StackParamList, 'HomeDrawer'>,
    DrawerNavigationProp<DrawerParamList, 'PedidosPage'>
  >;
};

const PedidosPage: React.FC<Props> = (props) => {
  const { navigation } = props;

  const [pedidos, setPedidos] = useState<Pedido[]>([]);

  const getPedidos = async () => {
    try {
      const res = await pedidoApi.getMany();
      setPedidos(res);
    } catch (err) {
      console.log(err);
      setTimeout(() => {
        getPedidos();
      }, 5000);
    }
  };

  useEffect(() => {
    getPedidos();
  }, []);

  return (
    <PageContainer scrollView={true} header={<Header titulo={'Meus Pedidos'} goBack />}>
      <View style={styles.content}>
        {pedidos.length === 0 && <ActivityIndicator size={50} color={colors.primary} />}
        {pedidos.map((pedido) => (
          <ItemPedido key={pedido.id} pedido={pedido} goToPedido={() => {}} />
        ))}
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  content: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingTop: TOP_PADDING,
    width: '100%',
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  }
});

export default PedidosPage;
